import React from "react";
import getClassNameFactory from "../../../../../../../../utilities/classNames";

var Tag = function Tag(_ref) {
  var children = _ref.children;
  var getClassName = getClassNameFactory("SearchResults");
  return /*#__PURE__*/React.createElement("li", {
    className: getClassName({
      descendantName: "tagFooterTag"
    })
  }, children);
};

export default Tag;